import { useSearchParams } from "react-router-dom";
import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import { LEGACY_DEVELOPMENTS } from "./Home";

const INTEREST_OPTIONS = [...LEGACY_DEVELOPMENTS, "A new or upcoming development", "General real-estate enquiry"];

export default function SiteVisit() {
  const [params] = useSearchParams();
  const preselect = params.get("project") || "";
  const preselectName = LEGACY_DEVELOPMENTS.find((d) => d.toLowerCase().replace(/[^a-z0-9]+/g, "-") === preselect);

  return (
    <div data-testid="site-visit-page" className="pt-28 sm:pt-36">
      <SEO title="Book a Site Visit — RK Builders"
        description="Book a site visit with RK Builders across Sardhana, Lawar, Ramraj, Putthi, Khardoni, Mawana, Kharkhadi, Kharkhauda and Modinagar." />
      <section className="max-w-[900px] mx-auto px-5 sm:px-8 pb-28">
        <Reveal>
          <Eyebrow>RK Builders</Eyebrow>
          <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4">
            Book a <span className="italic text-[#C5A059]">Site Visit</span>
          </h1>
          <p className="text-base text-[#94A3B8] leading-loose mt-6 max-w-2xl">
            Choose a project and a convenient time. Your request goes directly to the relevant project team,
            who will confirm the visit and arrange a walkthrough.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mt-12 border border-white/10 bg-[#0B1320] p-8 sm:p-12">
          <EnquiryForm
            type="site_visit"
            title="Visit Details"
            fields={[
              { name: "project", label: "Development of interest", type: "select", required: true,
                options: INTEREST_OPTIONS },
              { name: "visit_date", label: "Preferred date", type: "date", required: true },
              { name: "visit_time", label: "Preferred time", type: "time", required: true },
              { name: "interest", label: "Plot or villa interest", type: "select", options: ["Plot", "Villa", "Developed Land", "Not sure yet"] },
              { name: "budget", label: "Budget range", placeholder: "e.g. ₹20–40 lakh" },
              { name: "city", label: "Current city", required: true },
            ]}
          />
          {preselectName && (
            <p className="text-xs text-[#C5A059] mt-4">Development pre-selected from your browsing: {preselectName}</p>
          )}
        </Reveal>
      </section>
    </div>
  );
}
